import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as actions from '../../../redux/scriptEditor/actions.scriptEditor';
import * as _ from 'lodash';
import device from '../../../services/mini/device';
import { IStore } from '../../../redux/initialState';
import { ISetReplaceTermParams, ISetSearchTermParams, IShowSearchParams } from '../../../redux/scriptEditor/actions.scriptEditor';
const CodeMirror = require('codemirror/lib/codemirror');

type EditorSearchProps = PropsFromRedux & {
    searchKey: string;
    allowReplace: boolean;
    getScriptEditorCm: () => any;
}

type EditorSearchState = {
    replaceText: string;
}

// todo : rename this component to EditorSearch
class EditorSearch extends React.Component<EditorSearchProps, EditorSearchState> {

    searchEl = React.createRef<HTMLInputElement>();

    constructor(props) {
        super(props);

        this.state = {
            replaceText: '',
        };

        this.searchEl = React.createRef();
    }

    cmdBtn = () => {
        return device.isWindows() ? 'Ctrl' : 'CMD';
    }

    componentDidUpdate(prevProps) {
        if (prevProps.lastOpen !== this.props.lastOpen) {
            if (this.searchEl.current) {
                this.searchEl.current.focus();
                if (this.searchEl.current.value !== '') {
                    this.searchEl.current.select();
                }
            }
        }
    }

    showReplace = () => {
        this.props.show({
            searchKey: this.props.searchKey,
            showSearch: true,
            showReplace: true,
        });
    };

    close = () => {
        const cm = this.props.getScriptEditorCm();
        if (cm) {
            cm.execCommand('closeSearch');
        }
    };

    onPrevClick = () => {
        const cm = this.props.getScriptEditorCm();
        if (cm && this.props.searchTerm) {
            cm.execCommand('findPersistentPrev');
        }
    };

    onNextClick = () => {
        const cm = this.props.getScriptEditorCm();
        if (cm && this.props.searchTerm) {
            cm.execCommand('findPersistentNext');
        }
    };

    replace = () => {
        const cm = this.props.getScriptEditorCm();
        if (cm && this.props.searchTerm) {
            cm.execCommand('replaceNext');
        }
    };

    replaceAll = () => {
        const cm = this.props.getScriptEditorCm();
        if (cm && this.props.searchTerm) {
            cm.execCommand('replaceAll');
        }
    };

    onSearchChange = (e) => {
        const { searchKey, setSearchTerm } = this.props;
        setSearchTerm({ searchKey, searchTerm: e.target.value });
        this.updateSearch();
    };

    onReplaceChange = (e) => {
        const { searchKey, setReplaceTerm } = this.props;
        setReplaceTerm({ searchKey, replaceTerm: e.target.value });
    }

    updateSearch = _.debounce(() => {
        const cm = this.props.getScriptEditorCm();
        cm.execCommand('findUpdate');
    }, 250);

    onSearchKey = (e) => {
        if (e.which === 13 && this.props.searchTerm) {
            if (e.shiftKey) {
                this.onPrevClick();
            } else {
                this.onNextClick();
            }
        }
    };

    onReplaceKey = (e) => {
        if (e.which === 13 && this.props.searchTerm) {
            if ((e.ctrlKey || e.metaKey) && e.altKey) {
                this.replaceAll();
            } else {
                this.replace();
            }
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
    };

    render() {
        const { totalSearchResults, currentSearchItem } = this.props;

        const metaText = totalSearchResults ?
            `${currentSearchItem} / ${totalSearchResults}` :
            'No results';
        return (
            <form className={`editor-search ${this.props.showSearch && 'editor-search_visible'}`} onSubmit={this.onSubmit}>
                <div className="editor-search__row">
                    {
                        !this.props.showReplace && this.props.allowReplace &&
                        <i onClick={this.showReplace}
                            title={`Replace (${this.cmdBtn} + Shift + F)`}
                            className="icon icon-alan-replace editor-search__icon editor-search__icon_replace"></i>
                    }
                    <i className="icon icon-alan-search2 editor-search__icon editor-search__icon_search"></i>
                    <input className="editor-search__input"
                        tabIndex={1}
                        placeholder="Search"
                        ref={this.searchEl}
                        value={this.props.searchTerm}
                        onChange={this.onSearchChange}
                        onInput={this.onSearchChange}
                        onKeyDown={this.onSearchKey}
                    />
                    <div className={`editor-search__meta ${!this.props.totalSearchResults && 'editor-search__meta_no-results'}`}>
                        {this.props.searchTerm && metaText}
                    </div>
                    <div className="editor-search__button-wrap">
                        <div onClick={this.onPrevClick}
                            title="Previous (Shift + Enter)"
                            className={`editor-search__button editor-search__button_small ${!totalSearchResults && 'disabled'}`}>
                            <i className="icon icon-alan-arrow-rounded editor-search__icon editor-search__icon_arrow editor-search__icon_arrow_up"></i>
                        </div>
                        <div onClick={this.onNextClick}
                            title="Next (Enter)"
                            className={`editor-search__button editor-search__button_small ${!totalSearchResults && 'disabled'}`}>
                            <i className="icon icon-alan-arrow-rounded editor-search__icon editor-search__icon_arrow"></i>
                        </div>
                        <div onClick={this.close}
                            title="Close (Esc)"
                            className="editor-search__button editor-search__button_small">
                            <i className="icon icon-alan-close-rounded editor-search__icon editor-search__icon_close"></i>
                        </div>
                    </div>
                </div>
                {
                    this.props.showReplace && this.props.allowReplace &&
                    <div className="editor-search__row">
                        <i className="icon icon-alan-replace editor-search__icon editor-search__icon_search"></i>
                        <input value={this.props.replaceTerm}
                            tabIndex={2}
                            onChange={this.onReplaceChange}
                            onInput={this.onReplaceChange}
                            onKeyDown={this.onReplaceKey}
                            className="editor-search__input js-replace"
                            type="text"
                            placeholder="Replace"
                        />
                        <div className="editor-search__button-wrap">
                            <div onClick={this.replace}
                                title="Replace (Enter)"
                                className={`editor-search__button js-replace-confirm ${!totalSearchResults && 'disabled'}`}>
                                Replace
                            </div>
                        </div>
                        <div className="editor-search__button-wrap">
                            <div onClick={this.replaceAll}
                                title={`Replace All (${this.cmdBtn} + Alt + Enter)`}
                                className={`editor-search__button js-replace-all ${!totalSearchResults && 'disabled'}`}>
                                Replace All
                            </div>
                        </div>
                    </div>
                }
            </form>
        );
    }
}

function mapStateToProps({ scriptEditor }: IStore, ownProps) {
    const searchPanel = scriptEditor.searchPanels[ownProps.searchKey];
    return {
        showSearch: searchPanel?.showSearch,
        showReplace: searchPanel?.showReplace,
        searchTerm: searchPanel?.searchTerm || '',
        replaceTerm: searchPanel?.replaceTerm || '',
        totalSearchResults: searchPanel?.totalSearchResults,
        currentSearchItem: searchPanel?.currentSearchItem,
        lastOpen: searchPanel?.lastOpen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        show(params: IShowSearchParams) {
            dispatch(actions.showSearch(params));
        },
        setSearchTerm(params: ISetSearchTermParams) {
            dispatch(actions.setSearchTerm(params));
        },
        setReplaceTerm(params: ISetReplaceTermParams) {
            dispatch(actions.setReplaceTerm(params));
        },
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connect(mapStateToProps, mapDispatchToProps)(EditorSearch);
